export const alertStyle = {
	mb: 2,
	backgroundColor: '#e3f2fd',
	color: '#0d47a1',
	'& .MuiAlert-icon': {
		color: '#0d47a1',
		display: 'flex',
		alignItems: 'center',
	},
}
